import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v6","key":"svg-0"}],["path",{"d":"M16 19h6","key":"svg-1"}]]

/**
 * IconFolderMinus
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZm9sZGVyLW1pbnVzIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMiAxOWgtN2EyIDIgMCAwIDEgLTIgLTJ2LTExYTIgMiAwIDAgMSAyIC0yaDRsMyAzaDdhMiAyIDAgMCAxIDIgMnY2IiAvPgogIDxwYXRoIGQ9Ik0xNiAxOWg2IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/folder-minus
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconFolderMinus = createReactComponent('outline', 'folder-minus', 'FolderMinus', __iconNode);

export default IconFolderMinus;